import * as M from "three";
function A(t, n, e) {
  return t + (n - t) * e;
}
function Q(t, n, e, u, c, s, o, a, r) {
  let i = t * c + n * s + e * o + u * a, w = c, x = s, y = o, z = a;
  if (i < 0 && (i = -i, w = -c, x = -s, y = -o, z = -a), i > 0.9995) {
    const I = t + r * (w - t), P = n + r * (x - n), j = e + r * (y - e), p = u + r * (z - u), d = 1 / Math.sqrt(I * I + P * P + j * j + p * p);
    return {
      x: I * d,
      y: P * d,
      z: j * d,
      w: p * d
    };
  }
  const E = Math.acos(i), q = Math.sin(E), l = Math.sin((1 - r) * E) / q, h = Math.sin(r * E) / q;
  return {
    x: l * t + h * w,
    y: l * n + h * x,
    z: l * e + h * y,
    w: l * u + h * z
  };
}
function T(t, n, e) {
  const u = t * (Math.PI / 180), c = n * (Math.PI / 180), s = e * (Math.PI / 180), o = new M.Euler(u, c, s, "XYZ"), a = new M.Quaternion().setFromEuler(o);
  return {
    x: a.x,
    y: a.y,
    z: a.z,
    w: a.w
  };
}
function F(t, n, e, u) {
  const c = new M.Quaternion(t, n, e, u), s = new M.Euler().setFromQuaternion(c, "XYZ");
  return {
    x: s.x * (180 / Math.PI),
    y: s.y * (180 / Math.PI),
    z: s.z * (180 / Math.PI)
  };
}
export {
  T as eulerToQuaternion,
  A as lerp,
  F as quaternionToEuler,
  Q as slerp
};
//# sourceMappingURL=utils.js.map
